import { render, staticRenderFns } from "./SingleReferral.vue?vue&type=template&id=ba2f1bae&scoped=true&"
import script from "./SingleReferral.vue?vue&type=script&lang=js&"
export * from "./SingleReferral.vue?vue&type=script&lang=js&"
import style0 from "./SingleReferral.vue?vue&type=style&index=0&id=ba2f1bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2f1bae",
  null
  
)

export default component.exports